import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-file-doc_svg__a"
        d="M6.118 9.7h1.956c1.544 0 2.779 1.1 2.779 2.5s-1.132 2.5-2.78 2.5H6.119v-5zm1.956 1.2h-.515v2.6h.617c.721 0 1.339-.5 1.339-1.3s-.618-1.3-1.441-1.3zm4.838 1.3c0 .8.617 1.4 1.44 1.4.824 0 1.442-.6 1.442-1.4 0-.8-.618-1.4-1.441-1.4-.824 0-1.441.6-1.441 1.4zm4.323 0c0 1.4-1.235 2.7-2.882 2.7s-2.882-1.2-2.882-2.7c0-1.5 1.235-2.7 2.882-2.7s2.882 1.3 2.882 2.7zm2.06 0c0 .8.617 1.4 1.44 1.4.927 0 1.441-.6 1.441-.6l.824.9s-.72 1-2.265 1c-1.647 0-2.882-1.2-2.882-2.7 0-1.5 1.235-2.7 2.882-2.7 1.441 0 2.162 1 2.162 1l-.823.9s-.515-.6-1.339-.6c-.823 0-1.44.6-1.44 1.4zM18.47 6V4c0-1.1-.927-2-2.06-2H4.06C2.926 2 2 2.9 2 4v16c0 1.1.926 2 2.059 2h12.353c1.132 0 2.059-.9 2.059-2v-2h-2.06v2H4.06V4h12.353v2h2.059z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-file-doc_svg__a"
    />
  </svg>
);
